import { Injectable } from '@angular/core';

import { AuthService } from '../service/auth.service';

import { Clinic } from '../clinic/clinic';
import { Patient } from '../patient/patient';
import { Prescription } from '../prescription/prescription';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionPrint {

  constructor(private authService: AuthService) {}

  execute(patient: Patient, prescription: Prescription): void {

    let user = this.authService.currentUser;
    let clinics = this.authService.healthGroup.clinics;

    let newWin = window.open('', '_blank', 'top=0, left=0, height=50%, width=auto');
    newWin.document.open();
    newWin.document.write(`
      <html>
        <head>
          <link href="https://fonts.googleapis.com/css?family=Great+Vibes&display=swap" rel="stylesheet">
          <link href="https://fonts.googleapis.com/css?family=Roboto&display=swap" rel="stylesheet">
          <style>
            .header, .header-space,
            .footer, .footer-space {
              height: 100px;
              width: 100%;
            }

            .header {
              position: fixed;
              top: 0;
            }

            .footer {
              position: fixed;
              bottom: 0px;
              font-family: 'Roboto', sans-serif;
              font-size: 10px;
            }

            p {
              margin: 0px;
            }
          </style>
        </head>
    `);

    // Prescription HEADER
    if (user.use_headers) {
      newWin.document.write(`
        <body>
          <table>
            <thead><tr><td>
              <div class="header-space">
                <div style="text-align: right;" class="header">
      `);

      // TODO: Terrible hack. The things I do for my wife...
      if (user.email == 'danielletorreao@gmail.com') {
        newWin.document.write(`<div style="font-family: 'Great Vibes', cursive; font-size: 30px; margin: 0px 20px 0px 0px;"><em>${user.name}</em></div>`);
      } else {
        newWin.document.write(`<div style="font-family: 'Roboto', sans-serif; font-size: 30px; margin: 0px 20px 0px 0px;">${user.name}</div>`);
      }

      newWin.document.write(`
                  <div style="font-family: 'Roboto', sans-serif; font-size: 15px; margin: -5px 20px 0px 0px;"><small><em>${user.titles}</em></small></div>
                  <hr style="margin-left: 0px; width: 98%; border: 1px solid black; height: 1px; background-color: #000">
                </div>
              </div>
              </td></tr>
            </thead>
          <tbody><tr><td>
          <div style="margin-top: -30px;">
      `);

    } else {
      newWin.document.write('<body style="margin: 85px 0px 0px 0px;">');
    }

    // Prescription BODY
    if (patient) {
      newWin.document.write(`
            <div style="font-family: 'Roboto', sans-serif;">
              <span>Para,</span>
              <br />
              <span>${patient.name}</span>
              <br />

              <br />
              <span>Receita,</span>
              <br />
              <br />
      `);
    }

    newWin.document.write(`
            <span style="white-space: pre-line;">${prescription.text}</span>
            <br />
            <br />
            <br />

            <span>${this.authService.getSelectedClinic().city}, ${this.toPrintingDate(prescription.date)}</span>
            <br />
            <br />
            <br />
            <br />

            <div style="width: 350px; margin-left: 175px; text-align: center;">
              ${user.name}
            </div>
    `);

    if (!user.use_headers) {
      newWin.document.write(`
        <div style="width: 350px; margin-left: 175px; text-align: center;">
          ${user.crm_info}
        </div>
      `);
    }

    newWin.document.write('</div>');
    // END prescription BODY

    // Prescription FOOTER
    if (user.use_headers) {
      newWin.document.write(`
              </div>
            </td></tr>
          </tbody>
          <tfoot><tr><td>
            <div class="footer-space">
              <div class="footer">
                <hr style="width: 98%; margin-left: 0px; border: 1px solid black; height: 1px; background-color: #000">
      `);


      // TODO: Terrible hack. The things I do for my wife...
      if (user.email == 'danielletorreao@gmail.com') {

          newWin.document.write(`
            <div style="text-align: center;">
              <div style="font-family: 'Roboto'; font-size: 16px;">.: Nova Clínica :.</div>
              <div style="font-size: 12px;">Av. da Integração, 240, &nbsp;&nbsp;Vila Eduardo - Petrolina &nbsp;&nbsp;(87) 3861-4812 / (87) 98119-6901</div>
              <div style="font-size: 12px;"><img style="vertical-align: sub;" src="/assets/image/instagram-icon.png" width="12" height="12" /> @danielletorreao</div>
            </div>
          `);

      } else {

        if (clinics[0]) {
          let clinic: Clinic = clinics[0];
          newWin.document.write(`
            <div style="float: left; margin: 0px 100px 0px 10px;">
              <div>${clinic.name}</div>
              <div>${clinic.address}</div>
              <div>${clinic.county} - ${clinic.city}</div>
              <div>${clinic.phone}</div>
            </div>
          `);

          if (clinics[1]) {
            let clinic: Clinic = clinics[1];
            newWin.document.write(`
              <div style="float: left; margin-right: 100px;">
              <div>${clinic.name}</div>
              <div>${clinic.address}</div>
              <div>${clinic.county} - ${clinic.city}</div>
              <div>${clinic.phone}</div>
            </div>
            `);

            if (clinics[2]) {
              let clinic: Clinic = clinics[2];
              newWin.document.write(`
                <div>
                <div>${clinic.name} - ${clinic.phone}</div>
              `);

              if (clinics[3]) {
                let clinic: Clinic = clinics[3];
                newWin.document.write(`
                  <br />
                  <div>${clinic.name} - ${clinic.phone}</div>
                  </div>
                `);
              }
            }
          }
        }
      }

      newWin.document.write(`
              </div>
            </div>
          </tr></td>
        </tfoot>
      </table>
      `);
    }

    newWin.document.write('</body></html>');
    newWin.document.close();
  }

  private toPrintingDate(date: any): string {
    var months: string[] = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    if (date instanceof Date) {
      return `${date.getDate()} de ${months[date.getMonth()]} de ${date.getFullYear()}`;

    } else {
      let dateInfo = date.split('-');
      return dateInfo[2] + ' de ' + months[dateInfo[1] - 1] + ' de ' + dateInfo[0];
    }
  }
}
